import { render, staticRenderFns } from "./Info.vue?vue&type=template&id=3056e081&scoped=true&"
var script = {}
import style0 from "./Info.vue?vue&type=style&index=0&id=3056e081&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3056e081",
  null
  
)

export default component.exports